module.exports = __webpack_public_path__ + "img/slide11.5c01ef4a.jpg";